import axios from "axios";

export const simpAxios = axios.create({
    baseURL: process.env.REACT_APP_AIO_API_URL + "/rebate-widget",
    headers: { Authorization: process.env.REACT_APP_SIMP_TOKEN },
});
